<div class="content">
  <div class="card">
    <div class="card-header header-elements-inline" [ngBusy]="busy">
      <h6 class="card-title">
        <span *ngIf="!isEditMode">
          Ajouter un sous-collaborateur
          <span *ngIf="parentCollaborateur" class="text-muted">
            — de <strong>{{ parentCollaborateur.prenom }} {{ parentCollaborateur.nom }}</strong>
          </span>
        </span>
        <span *ngIf="isEditMode">
          Modifier le sous-collaborateur
          <span *ngIf="parentCollaborateur" class="text-muted">
            — de <strong>{{ parentCollaborateur.prenom }} {{ parentCollaborateur.nom }}</strong>
          </span>
        </span>
      </h6>
      <div class="heading-elements">
        <button
          type="button"
          class="btn btn-info btn-xs"
          (click)="goBack()"
        >
          <i class="icon-arrow-left14 position-left"></i>Retour à la liste
        </button>
      </div>
    </div>

    <br />

    <div class="card-body">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row">
          <!-- Prénom -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Prénom <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                formControlName="prenom"
                placeholder="Entrer le prénom"
              />
              <span
                class="text-danger"
                *ngIf="form.get('prenom')?.invalid && form.get('prenom')?.touched"
              >
                Le prénom est obligatoire
              </span>
            </div>
          </div>

          <!-- Nom -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Nom</label>
              <input
                type="text"
                class="form-control"
                formControlName="nom"
                placeholder="Entrer le nom"
              />
            </div>
          </div>
        </div>

        <div class="row">
          <!-- Email -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                class="form-control"
                formControlName="email"
                placeholder="Entrer l'email"
              />
              <span
                class="text-danger"
                *ngIf="form.get('email')?.invalid && form.get('email')?.touched"
              >
                Email invalide
              </span>
            </div>
          </div>

          <!-- Poste -->
          <div class="col-md-6">
            <div class="form-group">
              <label>Poste</label>
              <input
                type="text"
                class="form-control"
                formControlName="poste"
                placeholder="Entrer le poste"
              />
            </div>
          </div>
        </div>

        <!-- Champ caché parent_id -->
        <input type="hidden" formControlName="parent_id" />

        <div class="row mt-3">
          <div class="col-md-12">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="form.invalid"
            >
              <i class="icon-floppy-disk position-left"></i>
              {{ isEditMode ? 'Modifier' : 'Ajouter' }}
            </button>
            <button
              type="button"
              class="btn btn-default ml-2"
              (click)="goBack()"
            >
              Annuler
            </button>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>